import Box from '@mui/material/Box';
import styled from '@mui/material/styles/styled';
import useTheme from '@mui/material/styles/useTheme';
import useMediaQuery from '@mui/material/useMediaQuery';
import PropTypes from 'prop-types';

import Text from '../../elements/text/Text';

const StyledBox = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  textAlign: 'center',
  padding: `${theme.spacing(5)} ${theme.spacing(3)}`,
}));

const NoContent = ({ title, button }) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <StyledBox data-testid="no-content">
      {isSmallScreen ? (
        <Box>
          <Text caption color="textSecondary">
            {title}
          </Text>
          {button}
        </Box>
      ) : (
        <Box>
          <Text subtitle color="textSecondary">
            {title}
          </Text>
          {button}
        </Box>
      )}
    </StyledBox>
  );
};

export default NoContent;

NoContent.propTypes = {
  title: PropTypes.string.isRequired,
  button: PropTypes.node,
};
